import React, { useState, useLayoutEffect, Children } from 'react';
import PropTypes from 'prop-types';
import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import Icon from '../../icon';

const BurgerMenu = ({ children, className, reset }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  useLayoutEffect(() => {
    if (reset) {
      setIsOpen(false);
    }
  }, [reset]);

  return (
    <div
      className={`burger-menu-container ${className}`}
      id="burger-menu-container"
    >
      <ButtonLink
        className="button-link-secondary button-link-icon"
        icon={isOpen ? Icon.Cross : Icon.List}
        onClick={onClick}
      >
        <span className="u-hide-visually">Expand menu</span>
      </ButtonLink>

      {isOpen ? (
        <div className="menu-items">
          <ol
            id="burger-menu-list"
            className="burger-menu-list u-padding-m-hor"
          >
            {Children.map(children, item => (<li className="u-margin-m-ver">{item}</li>))}
          </ol>
        </div>
      ) : null }
    </div>
  );
};

BurgerMenu.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  reset: PropTypes.bool,
};

BurgerMenu.defaultProps = {
  reset: false,
};

export default BurgerMenu;
